import network from "@/api/network";

export default class Invite {
  static async getInviteList() {
    return await network.post("invites/list/user/current", null, {});
  }

  static async exportInviteList(config) {
    return await network.post("invites/list/user/current/download", null, config);
  }

  static async inviteAllUsers() {
    return await network.post("invites/user/current/resend/all", null, {});
  }

  static async inviteSingleUser(data) {
    return await network.post("invites/user/current/resend", data, {});
  }

  static async inviteManually(data) {
    return await network.post("invites", data, {});
  }

  static async inviteAutomatically(data) {
    return await network.post("invites/import", data, {});
  }

  static async getInvitationQueueStatus(id) {
    return await network.get(`invites/tasks/${id}/import/status`, null, {});
  }

  static async getInvitationQueueStatusAll(id) {
    return await network.get(`invites/tasks/${id}/resend/status`, null, {});
  }

  static async getInviteInfo(id) {
    return await network.get(`invites/${id}`, null, {});
  }

  static async getReferralInfo(code) {
    return await network.get(`referral/${code}`, null, {});
  }
}
